import React from 'react';
import ReactDOM from 'react-dom';
import { compact } from 'lodash';
import './antd.css';
import './index.css';
import './business/styles/style.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { StripeProvider } from 'react-stripe-elements';
import Crisp from 'components/common/Crisp';
import createSagaMiddleware from 'redux-saga';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { logger } from 'redux-logger';

import ducks from 'ducks';
import './i18n';

const sagaMiddleware = createSagaMiddleware();

const middlewares = compact([
  sagaMiddleware,
  process.env.NODE_ENV !== 'production' && logger
]);

const store = createStore(
  combineReducers(ducks.reducers),
  applyMiddleware(...middlewares)
);

sagaMiddleware.run(ducks.rootSaga);

const root = (
  <React.Suspense fallback={null}>
    <StripeProvider apiKey={process.env.REACT_APP_STRIPE_KEY}>
      <Provider store={store}>
        <Crisp />
        <App />
      </Provider>
    </StripeProvider>
  </React.Suspense>
);

ReactDOM.render(root, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
